import axios from 'axios'

const state = () => ({
  items: [],
})

const getters = {
  provinces: state => state.items,
  find: state => id => state.items.find(province => province.id === id),
  districts: state => provinceId => {
    const province = state.items.find(province => province.id === provinceId)

    if (province && province.districts) {
      return province.districts
    }

    return []
  },
}

const mutations = {
  SET_PROVINCES (state, provinces) {
    state.items = provinces
  },
}

const actions = {
  async index ({ commit }, params) {
    try {
      const { data } = await axios.get('/provinces', { params })
      commit('SET_PROVINCES', data.data)
    } catch (error) {
      console.log(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}